import { render, staticRenderFns } from "./materialsList.vue?vue&type=template&id=3d86e510&"
import script from "./materialsList.vue?vue&type=script&lang=js&"
export * from "./materialsList.vue?vue&type=script&lang=js&"
import style0 from "./materialsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports